import { render, staticRenderFns } from "./vipCardList.vue?vue&type=template&id=e25c205a&"
import script from "./vipCardList.vue?vue&type=script&lang=js&"
export * from "./vipCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vipCardList.vue"
export default component.exports